export default __webpack_public_path__ + "static/media/mockup42.edc54ffd.png";